import { orderBy } from 'lodash'

interface StudyLike {
  startAt?: string
  products?: string[]
}

/**
 * Order products by the startAt of the study they belong to (earliest first).
 * The appointment products attribute is an unordered Set, while studies are sorted
 * by startAt, so this keeps the procedure order consistent with the studies (PIA-2633).
 * Products not found in any study are kept at the end.
 */
export function orderProductsByStudyStart<T extends { id: string }>(products: T[], studies?: StudyLike[]): T[] {
  if (products.length <= 1 || !studies?.length) {
    return products
  }

  const startByProductId = new Map<string, string>()
  for (const study of studies) {
    if (!study.startAt) {
      continue
    }
    for (const productId of study.products ?? []) {
      if (!startByProductId.has(productId)) {
        startByProductId.set(productId, study.startAt)
      }
    }
  }

  return orderBy(products, (product) => startByProductId.get(product.id) ?? '~')
}
